import { render, staticRenderFns } from "./PriceHome.vue?vue&type=template&id=63d3d566&scoped=true"
import script from "./PriceHome.vue?vue&type=script&lang=js"
export * from "./PriceHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3d566",
  null
  
)

export default component.exports